import UserCookie from 'vue-cookies'
import store from '../../store'

export default async function availableForACU ({ next }) {
    const isLoggedIn = UserCookie.get('loggedin')
    const isProvider = UserCookie.get('user_type') && UserCookie.get('user_type') === 'provider'
    const providerId = UserCookie.get('provider_id')
    if (!isLoggedIn && isProvider && providerId) {
        return next('/')
    }
    try {
        await store.dispatch('hasAcuAccess')
        const msuCodeFromStore = store.getters.hasAcuAccessData && store.getters.hasAcuAccessData.data
        if (msuCodeFromStore) {
            return next()
        } else {
            return next('/')
        }
    } catch (error) {
        console.error('Error fetching MSU qualification list:', error)
        return next('/')
    }
}
